"use client";

import React from "react";
import { ArrowUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
export default function Noga() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  return <section data-section-id="253048" id="fußzeile" className="bg-background text-foreground py-12 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <Separator className="bg-border/50 mb-6" />
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="flex-1 flex justify-center sm:justify-start">
            <Link to="/" className="font-default font-medium text-sm tracking-widest uppercase hover:text-accent-foreground transition-colors">
              © Gedankengänge
            </Link>
          </div>
          
          <div className="flex items-center gap-6">
            <span className="font-default text-[0.75rem] uppercase tracking-widest text-muted-foreground">
              INSTA / TWTR
            </span>
            <Button variant="ghost" size="icon" onClick={scrollToTop} className="rounded-none hover:bg-transparent hover:text-accent-foreground transition-all duration-300" aria-label="Nach oben">
              <ArrowUp className="size-4 stroke-[1px]" />
            </Button>
          </div>
        </div>
      </div>
    </section>;
}